import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e7c66c2a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c66c2a')) {
      api.createRecord('e7c66c2a', component.options)
    } else {
      api.reload('e7c66c2a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e7c66c2a&", function () {
      api.rerender('e7c66c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hoM1cMGsbZrG/JS/comp/childrenage.vue"
export default component.exports